<button sdButton type="primary" fullWidth="true" (click)="addToCartIfNeed()">
  @if (product.isRent) {
    взять в аренду
  } @else {
    в корзину
  }
</button>
